export const NO_SELECTED = '请选择要操作的数据！'
export const DELETE_SURE_TEXT = '您确定删除吗？'
export const REVOKE_SURE_TEXT = '您确定撤销吗？'
export const CANCEL_SURE_TEXT = '您确定取消吗？'
export const SUBMIT_SURE_TEXT = '您确定提交吗？'
export const DELETE_MODAL_TITLE = '确认删除'
export const SUBMIT_MODAL_TITLE = '确认提交'
export const EXAMINE_MODAL_TITLE = '确认审核'
export const REVOKE_MODAL_TITLE = '确认撤销'
export const CANCEL_MODAL_TITLE = '确认取消'
export const UPLOAD_SUCCESS = '上传成功！'
export const DELETE_SUCCESS = '删除成功！'
export const UNDO_SUCCESS = '撤销成功！'
export const SAVE_SUCCESS = '保存成功！'
export const CANCEL_SUCCESS = '取消成功！'
export const SUBMIT_SUCCESS = '提交成功！'
export const AUDIT_SUCCESS = '审核成功'
export const HANDLER_MODAL_TITLE = '小提示'
export const OK_TEXT = '确定'
export const CANCEL_TEXT = '取消'
export const EXAMINE_TEXT = '审核'
export const REVOKE_TEXT = '撤销'
export const NETWORK_ERRORS = '网络错误，请稍后再试！'
export const NETWORK_OFF = '网络断开，请检查网络！'
export const NO_DATA = '暂无数据'
